module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1XH1A"))).then(() => parcelRequire('5erN3'));